export class TaskCropImageModel {
  /**Base64 или url на изображение */
  Base64OrUrl!: string;
  /**Название изображения (с расширением) */
  FileName!: string;
  /**Сжать ли файл */
  CompressFile: boolean = false;  
  
  constructor(obj?: Partial<TaskCropImageModel>) {
    Object.assign(this, obj);
  }
}